import StyledTableHead from 'Components/StyledTableHead'
import type { AfterpayPaymentEventShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter } from 'Util/formatters'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const AfterpayPaymentEvents: FC<{
  events: AfterpayPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      {events.map(event => (
        <TableRow key={event.id}>
          <TableCell>{datetimeFormatter(event.created)}</TableCell>
          <TableCell>{event.step}</TableCell>
          <TableCell>{event.description}</TableCell>
        </TableRow>
      ))}
    </>
  )
}

const AfterpayPaymentInfo: FC<{
  events: AfterpayPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Afterpay)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableHead>
        <TableRow>
          <TableCell>{t`Created`}</TableCell>
          <TableCell>{t`Step`}</TableCell>
          <TableCell>{t`Description`}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length > 0 ? (
          <AfterpayPaymentEvents events={events} />
        ) : (
          <TableRow>
            <TableCell>{t`No payment events available`}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  )
}

export { AfterpayPaymentInfo }
